import {useCallback, useState} from "react";


export default function useBottomSheet({initialState = true, onClose}: BSLProps): BottomSheetProps {
	  const [isOpen, setIsOpen] = useState(initialState);
	  
	  const handleClose = useCallback((event, reason) => {
			 if (reason === "backdropClick" || reason === "escapeKeyDown") {
					return;
			 }
			 setIsOpen(false);
			 onClose();
	  }, []);
	  
	  const handleOpen = useCallback(() => {
			 setIsOpen(true);
	  }, []);

	  return {isOpen, handleClose, handleOpen};
}


export type BottomSheetProps = {
	  isOpen: boolean;
	  handleClose: (event: React.SyntheticEvent, reason: string) => void;
	  handleOpen: () => void;
}

export type BSLProps = {
	  uid: string;
	  onClose: () => void;
}